/**
 * WebSocket 枚举类型定义
 */

/**
 * 消息 ID 枚举
 */
export enum MessageId {
  // USLO 系列 - 用户登录相关
  USLO01 = 'USLO01', // 登录失败
  USLO02 = 'USLO02', // 登录成功
  USLO03 = 'USLO03', // 账号已登录
  USLO04 = 'USLO04', // 请求台桌配置
  USLO05 = 'USLO05', // 请求台桌列表
  USLO06 = 'USLO06', // 台桌配置信息
  USLO09 = 'USLO09', // 台桌列表信息
  USLO22 = 'USLO22', // 请求台桌详情
  USLO23 = 'USLO23', // 台桌详情更新
  USLO24 = 'USLO24', // 请求历史记录
  USLO25 = 'USLO25', // 台桌配置变更
  USLO28 = 'USLO28', // 客服系统网址
  USLO80 = 'USLO80', // 请求会员投注记录 (下注报表)
  USLO81 = 'USLO81', // 会员投注记录响应 (下注报表)

  // GRUN 系列 - 游戏运行相关
  GRUN00 = 'GRUN00', // 投注失败
  GRUN01 = 'GRUN01', // 撤销投注失败
  GRUN02 = 'GRUN02', // 游戏状态更新
  GRUN07 = 'GRUN07', // 下注确认
  GRUN11 = 'GRUN11', // 余额更新
  GRUN12 = 'GRUN12', // 台桌公告更新
  GRUN13 = 'GRUN13', // 会员被踢出游戏
  GRUN14 = 'GRUN14', // 下注结果
  GRUN15 = 'GRUN15', // 请求公告
  GRUN18 = 'GRUN18', // 修改密码失败
  GRUN19 = 'GRUN19', // 修改密码结果
  GRUN28 = 'GRUN28', // 游戏开始
  GRUN29 = 'GRUN29', // 公司电话
  GRUN35 = 'GRUN35', // 新开鞋
  GRUN39 = 'GRUN39', // 批量台桌公告
  GRUN42 = 'GRUN42', // 会员余额修改通知(充值/提现)
  GRUN44 = 'GRUN44', // 扑克牌数据
  GRUN46 = 'GRUN46', // 台桌已经结束
  GRUN52 = 'GRUN52', // 开牌信息(单张牌)
  GRUN53 = 'GRUN53', // 删除当前局的牌面信息
  GRUN54 = 'GRUN54', // 修改靴数据
  GRUN58 = 'GRUN58', // 会员余额修改通知(补款/扣款)
  GRUN63 = 'GRUN63', // 结算信息
  GRUN68 = 'GRUN68', // 当前营运的台桌信息
  GRUN69 = 'GRUN69', // 其他更新

  // NETPR 系列 - 网络相关
  NETPR3 = 'NETPR3', // 心跳
}

/**
 * 游戏类型
 */
export enum GameType {
  BJL = 'BJL', // 百家乐
  LHD = 'LHD', // 龙虎斗
  SNN = 'SNN', // 牛牛
  ZJH = 'ZJH', // 炸金花
  GZB = 'GZB', // 干瞪眼宝
  JSBJL = 'JSBJL', // 极速百家乐
}

/**
 * 游戏状态
 *
 * 参考: src/constants/index.ts 中的 TABLE_TIME_STATUS_LIST
 */
export enum GameStatus {
  CLOSED = 0, // 关台中(等开靴) - 靴次 <= 0
  SHUFFLING = 1, // 洗牌中 - 靴次 > 0, 局数 <= 0
  BETTING = 2, // 下注中 - 倒计时 > 0
  IDLE = 3, // 等开局 - 倒计时 = 0, 局数 <= 有效结果数
  SETTLING = 4, // 结算中 - 倒计时 = 0, 局数 > 有效结果数
}

/**
 * WebSocket 连接状态
 */
export enum WebSocketStatus {
  CONNECTING = 'connecting', // 连接中
  CONNECTED = 'connected', // 已连接
  DISCONNECTED = 'disconnected', // 已断开
  RECONNECTING = 'reconnecting', // 重连中
  ERROR = 'error', // 错误
}
